import { lp } from "./lp";
import { smooth } from "./smoothscroll";
import { slide } from "./slide";
import { resize } from "./resize";

lp();
slide();
smooth();
resize();
